import React, { Fragment } from 'react'
import { Row } from 'reactstrap'
import { injectIntl } from 'react-intl'
import { Colxx } from '../../../components/common/CustomBootstrap'
import EditorsSummaryChatGPT from './EditorsSummaryChatGPT'


function CreateSummary() {

  return (
    <Fragment>
      <Row>
        <Colxx xl="12" xxl="12" lg="12" className="mb-4">
          <EditorsSummaryChatGPT tool="paraphrase" />
        </Colxx>
      </Row>
    </Fragment>
  )
}
export default injectIntl(CreateSummary)
